import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  location: {
    display: 'flex',
    direction: 'row',
    alignItems: 'center',
    color: '#696969',
    fontSize: '0.875rem',
    letterSpacing: '0.13px',
    lineHeight: '1.0625rem'
  },
  iconBtn: {
    padding: 0
  },
  formContainer: {
    marginTop: '0.5rem',
    backgroundColor: '#FFFFFF',
    border: '1px solid #979797',
    padding: '0.9375rem 1.8125rem 1.0625rem 1.25rem'
  },
  btnContainer: {
    marginTop: '0.875rem'
  },
  btn: {
    width: '6.25rem',
    borderRadius: '4px',
    fontSize: '0.75rem',
    lineHeight: '0.9375rem',
    letterSpacing: '0.21px',
    color: '#222222',
    backgroundColor: '#FCB400',
    '&:hover': {
      backgroundColor: '#FCB400'
    }
  },
  btnDisabled: {
    backgroundColor: '#C9C9C9'
  }
}));

export default useStyles;
